import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    gbpfilter: {
        adjustedLogic: [],
        alerts: [],
        clustername: [],
        futureSegmentation: [],
        l2: [],
        l3: [],
        material: [],
        materialDescription: [],
        mrpType: [],
        plant: [],
        poAlert: [],
        reviewedFlag: [],
        vendorName: []
    },
    selectedGBPFilter: {
        adjustedLogic: [],
        alerts: [],
        clustername: [],
        futureSegmentation: [],
        l2: [],
        l3: [],
        material: [],
        materialDescription: [],
        mrpType: [],
        plant: [],
        poAlert: [],
        reviewedFlag: [],
        vendorName: []
    },
    selectedPlantCode: {},
    token: null,
    tableSelection: [],
    windowSize: {},
    selectionFlag: false,
    applyFilter: {"status": false, "rowNo":-1},
    applyForecastFilter: {"status": false, "rowNo":-1},
    selectedClustername: [],
    lastUpdateDate: ""
};
  

const filterSlice = createSlice({
    name:"filter",
    initialState:initialState,
    reducers:{
        setFilter:(state,action)=>{
            state.gbpfilter = action.payload;
        },
        setSelectedGbpFilter:(state,action)=>{
            state.selectedGBPFilter = action.payload;
        },
        setPlant:(state,action)=>{
            state.selectedGBPFilter.plant = action.payload
        },
        setMaterial:(state,action)=>{
            state.selectedGBPFilter.material = action.payload
        },
        setGBPPlant:(state,action)=>{
            state.gbpfilter.plant = action.payload
        },
        setGBPMaterial:(state,action)=>{
            state.gbpfilter.material = action.payload
        },
        setL2:(state,action)=>{
            state.gbpfilter.l2 = action.payload;
        },
        setL3:(state,action)=>{
            state.gbpfilter.l3 = action.payload;
        },
        setMaterialDescription:(state,action)=>{
            state.gbpfilter.materialDescription = action.payload
        },
        setMrptype:(state,action)=>{
            state.gbpfilter.mrpType = action.payload
        },
        setFuturesegmentation:(state,action)=>{
            state.gbpfilter.futureSegmentation = action.payload
        },
        setVendorName:(state,action)=>{
            state.gbpfilter.vendorName = action.payload
        },
        setClusterName:(state,action)=>{
            state.gbpfilter.clustername = action.payload
        },
        setFilterData:(state,action)=>{
            state.selectedGBPFilter = action.payload
        },
        setPlantCodeFilter:(state,action)=>{
            state.selectedPlantCode = action.payload
        },
        setTokenData:(state,action)=>{
            state.token = action.payload
        },
        setTableFilter:(state,action)=>{
            state.tableSelection = action.payload
        },
        setWindowSize:(state,action)=>{
            state.windowSize = action.payload
        },
        setSelectionFlag:(state,action)=>{
            state.selectionFlag = action.payload;
        },
        setApplyFilter:(state,action)=>{
            state.applyFilter = action.payload;
        },
        setApplyForecastFilter:(state,action)=>{
            state.applyForecastFilter = action.payload;
        },
        setSelectedClusterName:(state,action)=>{
            state.selectedClustername = action.payload;
        },
        setLastUpdatedDate:(state,action)=>{
            state.lastUpdateDate = action.payload;
        }
    }
});

export const {
    setFilter,
    setPlant,
    setSelectedGbpFilter,
    setL2,
    setL3,
    setMaterialDescription,
    setMaterial,
    setMrptype,
    setFuturesegmentation,
    setVendorName,
    setClusterName,
    setFilterData,
    setPlantCodeFilter,
    setTokenData,
    setTableFilter,
    setWindowSize,
    setSelectionFlag,
    setGBPPlant,
    setGBPMaterial,
    setApplyFilter,
    setApplyForecastFilter,
    setSelectedClusterName,
    setLastUpdatedDate,
  } = filterSlice.actions;
  

export default filterSlice;